<template>
  <div :class="b()">
    <div class="master-title-div" v-if="option.titleShow">
      <span class="master-title" :style="titleStyle">
        {{ option.title }}
        <span v-if="option.titleSizeShow">({{ dataList.length || 0}})</span>
      </span>
      <template v-if="option.hasNav && hasData">
        <div :class="b('btn')">
          <div :class="b('btn--pre')" :style="btnStyle" @click="pre"></div>
          <div :class="b('btn--next')" :style="btnStyle" @click="next"></div>
        </div>
      </template>
    </div>
    <template v-if="hasData">
      <div class="master-tag" :style="divHeight">
        <div class="switch-div">
          <div class="switch-list">
            <div class="switch-content" :style="contentHeight" ref="tagContent">
              <transition name="fade">
                <ul ref="tagUl" class="list-complete-item">
                  <template v-for="tag in dataList">
                    <li
                      v-if="isSelect(tag.title)"
                      :key="tag.title"
                      :style="activeStyle"
                      @click="selectTag(tag.title)"
                    >
                      {{ tag.title }}
                    </li>
                    <li v-else :key="tag.title" :style="tagStyle" @click="selectTag(tag.title)">
                      {{ tag.title }}
                    </li>
                  </template>
                </ul>
              </transition>
            </div>
          </div>
        </div>
      </div>
      <div class="slave-tag">
        <div class="slave-scope bg" :style="slaveBackgroudColor">
          <div class="sub-title" :style="subTitleStyle" v-if="option.subTitleShow">
            {{ option.subTitle }}
            <span v-if="option.subTitleSizeShow"
              >({{ (tagMap.get(activateTag) && tagMap.get(activateTag).length) || 0 }})</span
            >
          </div>
          <div class="slave-div">
            <ul>
              <li v-for="tag in tagMap.get(activateTag)" :key="tag.title" :style="slaveStyle">
                <template v-if="option.hasLink">
                  <a :href="linkHref(tag)" :target="linkTarget" :style="slaveFontStyle">{{
                    tag.title
                  }}</a>
                </template>
                <template v-else>
                  <a href="javascript:;" :style="slaveFontStyle">{{ tag.title }}</a>
                </template>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <empty></empty>
    </template>
  </div>
</template>
<script>
import { parseUrl } from '@/utils/utils';
import { featchTags } from '@/api/cascade-tag';

export default {
  name: 'cascade-tag',
  props: {
    option: Object,
    component: Object
  },
  data() {
    return {
      navIndex: 0,
      navWidths: [],
      navLeft: 0,
      // private
      activateTag2: '',
      tagMap: new Map()
    };
  },
  computed: {
    titleStyle() {
      const { titleColor, titleFontSize = 18, titlePostion = 'left' } = this.option;
      return {
        color: titleColor,
        fontSize: this.setPx(titleFontSize),
        textAlign: titlePostion
      };
    },
    btnStyle() {
      return {
        width: (this.option.navSize || 22) + 'px',
        height: (this.option.navSize || 22) + 'px',
        background: this.option.navColor || '#3563aa'
      };
    },
    fontSize() {
      return this.option.fontSize || 30;
    },
    textWidth() {
      const textLen = (this.dataChart.value || '').length;
      return textLen * this.fontSize;
    },
    divHeight() {
      return {
        height: this.setPx(1.7 * this.fontSize),
        backgroundColor: this.option.backgroundColor
      };
    },
    contentHeight() {
      return {
        height: this.setPx(1.7 * this.fontSize)
      };
    },
    tagStyle() {
      return {
        width: this.scroll ? this.setPx(this.textWidth) : 'auto',
        transform: `translateX(${this.left}px)`,
        textAlign: this.option.textAlign,
        letterSpacing: this.setPx(this.option.split),
        textIndent: this.setPx(this.option.split),
        backgroundColor: this.option.fontBackgroundColor,
        fontWeight: this.option.fontWeight || 'normal',
        fontSize: `${this.fontSize}px`,
        color: this.option.color || '#fff'
      };
    },
    activeStyle() {
      const backgroundImage = () => {
        if (this.option.empBackgroundImage) {
          return {
            backgroundImage: `url(${this.option.empBackgroundImage})`,
            backgroundSize: '100% 100%'
          };
        }
        return {};
      };
      const active = {
        backgroundColor: this.option.empBackgroundColor,
        borderColor: this.option.empBorderColor || '#fff',
        borderStyle: 'solid',
        borderRadius: this.setPx(this.option.empBorderRadius || 0),
        borderWidth: this.setPx(this.option.empBorderWidth || 0),
        color: this.option.empColor || 'rgba(149, 211, 255, 1)'
      };
      return Object.assign({}, this.tagStyle, backgroundImage(), active);
    },
    subTitleStyle() {
      const { subTitleColor, subTitleFontSize = 12, subTitlePostion = 'left' } = this.option;
      return {
        color: subTitleColor,
        fontSize: `${subTitleFontSize}px`,
        textAlign: subTitlePostion
      };
    },
    dataList() {
      if (Array.isArray(this.dataChart)) {
        this.dataChart.forEach(tag => this.tagMap.set(tag.title, tag.children));
        return [...this.dataChart];
      }
      return [];
    },
    hasData() {
      return this.dataList.length > 0;
    },
    activateTag: {
      get() {
        if (this.activateTag2) {
          return this.activateTag2;
        }

        let result;
        if (Array.isArray(this.dataList)) {
          if (this.dataList[0]) {
            result = this.dataList[0].title;
          }
        }
        return result;
      },
      set(val) {
        this.activateTag2 = val;
      }
    },
    linkTarget() {
      return this.option.linkTarget || '_blank';
    },
    slaveStyle() {
      return {
        color: this.option.slaveColor || 'rgba(149, 211, 255, 1)',
        backgroundColor: this.option.slaveFontBackgroundColor,
        borderStyle: 'solid',
        borderColor: this.option.slaveBorderColor || '#fff',
        borderWidth: this.setPx(this.option.slaveBorderWidth || 0),
        borderRadius: this.setPx(this.option.slaveBorderRadius || 0)
      };
    },
    slaveFontStyle() {
      return {
        color: this.option.slaveFontColor || 'rgba(149, 211, 255, 1)',
        fontSize: this.setPx(this.option.slaveFontSize || 16)
      };
    },
    slaveBackgroudColor() {
      return {
        backgroundColor: this.option.slaveBackgroundColor
      }
    }
  },
  methods: {
    selectTag(title) {
      this.activateTag = title;
      this.fetchTags(title);
    },
    fetchTags(tag) {
      if (this.option.dynamicData) {
        const url = this.option.remoteUrl.replace(/{code}/g, tag);
        featchTags(url, this.option.remoteMethod).then(res => {
          const data = res.data ? res.data : [];
          this.tagMap.set(tag, data);
        });
      }
    },
    isSelect(title) {
      return title === this.activateTag;
    },
    pre() {
      if (this.navWidths.length < 1) {
        return;
      }

      this.navLeft += this.navWidths.pop();
      this.$refs.tagUl.style.left = `${this.navLeft}px`;
    },
    next() {
      if (this.navIndex + 1 >= this.dataList.length) {
        return;
      }

      const currentWidth = this.$refs.tagUl.children[this.navIndex++].clientWidth + 15;
      this.navLeft -= currentWidth;
      const diff = this.$refs.tagUl.clientWidth - this.$refs.tagContent.clientWidth;
      if (Math.abs(this.navLeft) - 80 > diff) {
        this.navLeft += currentWidth;
        return;
      }

      this.navWidths.push(currentWidth);
      this.$refs.tagUl.style.left = `${this.navLeft}px`;
    },

    linkHref(tag) {
      let { linkHref = '#' } = this.option;
      linkHref = parseUrl(linkHref, tag);
      return linkHref;
    }
  }
};
</script>

<style lang="scss" scoped>
.avue-echart-cascade-tag {
  .master-title-div {
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    margin-left: 15px;
    align-items: center;
    flex: none;

    .master-title {
      width: 100%;
      margin-top: 8px;
      color: #fff;
      font-size: 18px;
    }
  }

  .list-complete-item {
    transition: all 1s;
    display: inline-block;
    margin-right: 10px;
  }

  &__btn {
    margin-top: 8px;
    position: relative;
    min-width: 100px;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    &--pre,
    &--next {
      outline: none;
      width: 22px;
      height: 22px;
      border-radius: 2px;
      background: #3563aa;
      text-align: center;
      line-height: 22px;
      top: 0;
      margin: 0 5px;
      position: relative;
      cursor: pointer;
      &::after {
        content: '';
        font-size: 10px;
        width: 0;
        height: 0;
        border-top: 5px solid transparent;
        border-bottom: 5px solid transparent;
        position: absolute;
        top: 50%;
        left: 50%;
      }
    }
    &--pre {
      &::after {
        content: '';
        border-right: 5px solid #fff;
        border-left: 5px solid transparent;
        transform: translate(-75%, -50%);
      }
    }
    &--next {
      &::after {
        content: '';
        border-left: 5px solid #fff;
        border-right: 5px solid transparent;
        transform: translate(-25%, -50%);
      }
    }
  }

  .master-tag {
    display: flex;
    padding: 8px;

    .switch-div {
      width: 100%;
      display: flex;
      justify-content: center;

      .switch-list {
        width: 100%;
        border-radius: 2px;
        padding: 4px;
        display: flex;

        .switch-content {
          flex: 1;
          white-space: nowrap;
          overflow: hidden;
          position: relative;

          ul {
            display: flex;
            position: absolute;
            left: 0;
            overflow-x: auto;
            overflow-y: hidden;

            &::-webkit-scrollbar {
              display: none;
            }

            li {
              padding: 0 10px;
              text-align: center;
              cursor: pointer;
              margin: 0 5px;
              background: transparent;
              list-style: none;
            }
          }
        }
      }
    }
  }
  .slave-tag {
    display: flex;
    margin-top: 6px;
    margin-left: -15px;

    .sub-title {
      margin-top: 10px;
      color: #fff;
    }

    .slave-scope {
      height: calc(100% - 5px);
      width: 100%;
      margin-left: 15px;
      padding-top: 10px;
      padding-bottom: 10px;

      ul {
        display: flex;
        flex-wrap: wrap;
        margin-top: 10px;
        position: relative;
        z-index: 1;

        li {
          padding: 0 8px;
          border: 1px solid #95d3ff;
          // line-height: 26px;
          margin-right: 8px;
          margin-bottom: 8px;
          list-style: none;
        }
      }
    }

    .bg {
      padding: 0 16px;
      box-sizing: border-box;
    }

    .slave-div {
      width: 100%;
      height: calc(100% - 5px);
      overflow-y: auto;
    }
  }

  .avue-empty {
    height: 80%;
  }
}
</style>
